var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner-wrapper"},[_c('div',{attrs:{"event":"scroll"}},[_c('div',{staticClass:"float",attrs:{"strength":-100}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }